import { Link } from 'react-router-dom'

export function ForgotPasswordPage() {
  function submit() {
    console.log('TODO: trigger forgot password')
  }

  return (
    <div className={tailwind.container}>
      <div className="w-full max-w-xs mx-auto">
        <form>
          <div className="mb-3">
            <label className={tailwind.label}>Forgot Password</label>
            <input className={tailwind.inputText} id="email" type="text" placeholder="Email" />
          </div>
          <div className="flex items-center justify-between">
            <button className={tailwind.button} type="button" onClick={submit}>
              Sign In
            </button>
          </div>
          <div className="flex items-center justify-between mt-4">
            <div className="flex-row">
              Already have account?{' '}
              <Link className={tailwind.link} to="/login">
                Sign In
              </Link>
            </div>
          </div>
        </form>
      </div>
    </div>
  )
}

const tailwind = {
  container: 'mt-3',
  form: 'bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4',
  label: 'block text-gray-700 text-sm font-bold mb-2',
  inputText:
    'appearance-none border border-red-500 rounded w-full py-2 px-3 text-gray-700 mb-3 leading-tight focus:outline-none',
  button:
    'bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline',
  link: 'inline-block align-baseline font-bold text-blue-500 hover:text-blue-800 no-underline',
}
